import React, { useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { SurveyModal } from './components/ui/SurveyModal';
import { SurveyModalContext } from './hooks/use-survey-modal';
export function App() {
  const [isOpen, setIsOpen] = useState(false);
  return <SurveyModalContext.Provider value={{
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false)
  }} data-id="element-0">
      <LandingPage data-id="element-1" />
      <SurveyModal data-id="element-2" />
    </SurveyModalContext.Provider>;
}